import { Component, Inject, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth'
import { SettingsService, User, DrawerHelper } from '@delon/theme'
import { LayoutDefaultOptions } from '@delon/theme/layout-default'
import { environment } from '@env/environment'
import { AuthService } from '@shared/service/auth.service'

import { XiaoXingComponent } from './widgets/xiaoxing.component'

@Component({
  selector: 'layout-basic',
  styleUrls: ['./basic.component.less'],
  template: `
    <layout-default
      [options]="options"
      [asideUser]="asideUserTpl"
      [content]="contentTpl"
      [customError]="null"
    >
      <layout-default-header-item direction="left">
        <span class="title-basic">GreenPro</span>
      </layout-default-header-item>
      <layout-default-header-item direction="right">
        <div layout-default-header-item-trigger>
          <header-swap class="text-lg"></header-swap>
        </div>
      </layout-default-header-item>
      <layout-default-header-item direction="right">
        <div layout-default-header-item-trigger>
          <header-fullscreen class="text-lg" />
        </div>
      </layout-default-header-item>
      <layout-default-header-item direction="right">
        <div layout-default-header-item-trigger>
          <header-i18n showLangText="false" class="text-lg" />
        </div>
      </layout-default-header-item>
      <layout-default-header-item direction="right">
        <header-notify />
      </layout-default-header-item>
      <layout-default-header-item direction="right">
        <a routerLink="/admin/account" layout-default-header-item-trigger>
          <i nz-icon nzType="user"></i>
        </a>
      </layout-default-header-item>
      <!-- <layout-default-header-item direction="right">
        <div layout-default-header-item-trigger (click)="openXiaoxingDialog()">
          <i nz-icon nzType="question-circle"></i>
        </div>
      </layout-default-header-item> -->
      <layout-default-header-item direction="right">
        <div layout-default-header-item-trigger (click)="logout()">
          <i nz-icon nzType="logout"></i>
        </div>
      </layout-default-header-item>
      <ng-template #asideUserTpl></ng-template>
      <ng-template #contentTpl>
        <router-outlet />
      </ng-template>
    </layout-default>
  `,
})
export class LayoutBasicComponent implements OnInit {
  isMac = false
  options: LayoutDefaultOptions = {
    logoExpanded: `./assets/logo-full.png`,
    logoCollapsed: `./assets/logo.png`,
  }
  searchToggleStatus = false
  showSettingDrawer = !environment.production
  get user(): User {
    return this.settings.user
  }

  constructor(
    private settings: SettingsService,
    private router: Router,
    private modalHelper: DrawerHelper,
    private authService: AuthService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
  ) {}

  logout(): void {
    this.tokenService.clear()
    this.authService.setOwnedRoutersWithParams([])
    this.router.navigateByUrl(this.tokenService.login_url!)
  }

  ngOnInit(): void {
    document.oncontextmenu = function () {
      return false
    }
  }

  openXiaoxingDialog(): void {
    this.modalHelper
      .create(
        'AIGC',
        XiaoXingComponent,
        {
          record: { operation: 'show', height: `${document.body.clientHeight - 83}px` },
        },
        {
          drawerOptions: {
            nzWidth: 800,
          },
          footer: false,
        },
      )
      .subscribe((res) => {
        if (res.successful) {
        }
      })
  }
}
